// Incidencias de impresora (puro): lo comparten PrinterIssuesBanner, los
// selectores del layout y la pastilla de estado del TPV (src/realtime).

/**
 * Reason prioritizado. Si hay varias cosas rotas a la vez preferimos mostrar la
 * más concreta (lastError) sobre la genérica. Si no hay lastError, cascada:
 *   isConnected=false → "Desconectada"
 *   paperOk=false     → "Sin papel"
 *   coverOk=false     → "Tapa abierta"
 */
export function getIssueReason(printer) {
  if (printer.lastError) return printer.lastError;
  if (!printer.isConnected) return "Desconectada";
  if (!printer.paperOk) return "Sin papel";
  if (!printer.coverOk) return "Tapa abierta";
  return null;
}

export function getIssuePrinters(workers) {
  if (!workers) return [];
  // Solo importan impresoras de workers online — si el worker entero está offline,
  // la pastilla de estado ya avisa del worker; no duplicamos el ruido con chips ambiguos
  // (last known state puede estar desactualizado).
  return workers
    .filter((w) => w.isOnline)
    .flatMap((w) =>
      (w.printers || [])
        .map((p) => ({ ...p, _reason: getIssueReason(p) }))
        .filter((p) => p._reason !== null),
    );
}

// Fingerprint estable del set de incidencias actual. Lo usamos para
// invalidar el dismiss cuando el conjunto de problemas cambia: si el
// usuario cerró el banner con 2 impresoras desconectadas y luego se cae
// una tercera (o cambia el motivo de error de una de las dos), el
// fingerprint difiere del guardado en Redux y el banner reaparece.
export function computeIssuesFingerprint(issues) {
  return issues
    .map((p) => `${p.id || p.name}:${p._reason}`)
    .sort()
    .join("|");
}
